import React, {Component} from 'react'
import {applyMiddleware, createStore} from 'redux'
import {Provider} from 'react-redux'
import {MuiThemeProvider} from '@material-ui/core/styles'
import {CssBaseline} from '@material-ui/core'
import theme from './theme'
import mockData from './mockData'
import thunkMiddleware from 'redux-thunk'
import rootReducer from "./reducers/root"
import Base from './container/Base'

const {
    formData,
    paymentData,
    resultData,
    screen
} = window.data ? window.data : mockData

const initializeStore = (initialState = {}) => {
    const middleware = applyMiddleware(thunkMiddleware)

    return middleware(createStore)(
        rootReducer,
        initialState,
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
}

let store = initializeStore({
    formData,
    paymentData,
    resultData,
    screen,
    environment: process.env.NODE_ENV
})

class App extends Component {

    render() {
        return (
            <Provider store={store}>
                <MuiThemeProvider theme={theme}>
                    <CssBaseline/>
                    <Base/>
                </MuiThemeProvider>
            </Provider>
        )
    }
}

export default App
